import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
});

// Automatically attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const register = (data) => api.post('/auth/register', data);
export const login = (data) => api.post('/auth/login', data);
export const getMe = () => api.get('/auth/me');

// Trips
export const searchTrips = (params) => api.get('/trips', { params });
export const getTrip = (id) => api.get(`/trips/${id}`);
export const createTrip = (data) => api.post('/trips', data);
export const updateTrip = (id, data) => api.put(`/trips/${id}`, data);
export const deleteTrip = (id) => api.delete(`/trips/${id}`);
export const getTripBookings = (id) => api.get(`/trips/${id}/bookings`);

// Bookings
export const createBooking = (data) => api.post('/bookings', data);
export const getBooking = (id) => api.get(`/bookings/${id}`);
export const acceptBooking = (id) => api.put(`/bookings/${id}/accept`);
export const declineBooking = (id) => api.put(`/bookings/${id}/decline`);
export const cancelBooking = (id) => api.put(`/bookings/${id}/cancel`);

// Reviews
export const createReview = (data) => api.post('/reviews', data);
export const getUserReviews = (id) => api.get(`/reviews/user/${id}`);

// Messages
export const getMessages = (bookingId) => api.get(`/messages/${bookingId}`);
export const sendMessage = (data) => api.post('/messages', data);

// Users
export const getUser = (id) => api.get(`/users/${id}`);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const getUserTrips = (id) => api.get(`/users/${id}/trips`);
export const createMembershipPayment = () => api.post('/payments/membership/create');
export const confirmMembershipPayment = (data) => api.post('/payments/membership/confirm', data);
export default api;